import request from '../request';
// 获取未登录大牛案例6个
export const getTemplateIndex = params => {
  return request({
    url: '/v3/sample_cvs',
    method: 'get',
    params
  })
}

// CVS大牛简历模块
export const getSampleCvList = (params) => {
  return  request({
    url: '/v3/ad_sample_cvs',
    method: 'get',
    params
  })
}